import React, { useState } from "react";
import ic_person from "../img/ic_person.png";
import ic_settings from "../img/ic_settings.png";
import "../css/Header.css";
import ic_logout from "../img/ic_logout.png";
import { useNavigate } from "react-router-dom";
import ic_home_order_taking from "../img/ic_home_white.png";

function Header() {

    const navigate = useNavigate();

    const [showPopupState, setShowPopupState] = useState(false);

    const showHideLogoutPopup = () => {
        console.log("showHideLogoutPopup clicked");
        setShowPopupState(prev => !prev);
    }

    const logoutAction = (e) => {
        e.stopPropagation();
        console.log("logoutAction clicked");

        localStorage.setItem("cubix_order_taking_isAuthenticated", false);
        navigate('/')
        showHideLogoutPopup();
    }

    return (
        <div className="Header-root-container">

            <div className="Header-home-slaes-man-name">
                <a href="/home">
                    <img src={ic_home_order_taking} />
                </a>
                <div className="Header-user-name-container">

                    <label>{localStorage.getItem("cubix_order_taking_sales_man")}</label>
                </div>
            </div>



            <div>
                <img src={ic_settings} onClick={showHideLogoutPopup} />
            </div>

            {/* Logout popup section */}
            {showPopupState &&

                <div className="Header-logout-container">
                    <div className="Header-clickable-area-to-close" onClick={showHideLogoutPopup}>
                    </div>
                    <div className="Header-logout-card">
                        
                        <div className="Header-salesman-name-container">
                            <label>{localStorage.getItem("cubix_order_taking_sales_man")}</label>
                        </div>

                        <div className="Header-logout-card-logout-container" onClick={logoutAction}>
                            <img src={ic_logout} /><label className="Header-logout-card-name ms-2">Logout</label>
                        </div>

                    </div>
                </div>
            }
            {/* Logout popup section */}
        </div>
    )

}

export default Header;